/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

/**
 * ModuleFab — floating action button positioned above the bottom nav bar.
 *
 * 44px colored circle showing LayoutGrid icon. Tapping opens
 * the ModuleSwitcherOverlay. Only rendered when style === 'fab'.
 */

import { LayoutGrid } from 'lucide-react';

interface Props {
  color: string;
  onClick: () => void;
  isOpen: boolean;
}

export function ModuleFab({ color, onClick, isOpen }: Props) {
  return (
    <button
      className={`bn-fab${isOpen ? ' bn-fab-open' : ''}`}
      style={{ background: color }}
      onClick={onClick}
      type="button"
      aria-label="Switch module"
    >
      <LayoutGrid size={20} />
    </button>
  );
}
